import styled from "styled-components"
import { Paragraph } from "components/text"

export const CheckMark = styled.span`
  position: relative;
  height: 19px;
  width: 19px;
  min-width: 19px;

  background-color: ${props => props.theme.colors.white};
  border-radius: 50%;
  border: solid 1px ${props => props.theme.colors.evergreen};

  :after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    margin: 3px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
  }
`

export const Label = styled(Paragraph).attrs({
  as: "label"
})`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: fit-content;
  width: fit-content;

  &:not(:last-of-type) {
    margin-bottom: ${props => props.theme.space[4]};
  }

  :hover * {
    cursor: pointer;
  }

  :hover ${CheckMark}:after, :focus ${CheckMark}:after {
    background-color: ${props => props.theme.colors.gunmetal};
  }

  /* The focus state styling is provided so UX is not in danger */
  :focus-within ${CheckMark} {
    box-shadow: 0 0 5px ${props => props.theme.colors.melrose}, 0 0 5px ${props => props.theme.colors.melrose},
      0 0 5px ${props => props.theme.colors.melrose};
  }
`

export const Input = styled.input`
  /*
    This positions a transparent input right behind the circle that mimicks it
  */
  position: absolute;
  opacity: 0;

  :checked ~ ${CheckMark}:after {
    display: block;
    background: ${props => props.theme.colors.evergreen};
  }
`
